<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
  <div class="d-flex flex-column">
    <label
      class="form-label small text-muted mb-1"
      for="adminorcustomer_organizations_soarrules_serviceaccounts_filter_sensitivity"
    >
      Sensitivity/Function
    </label>
    <kendo-dropdownlist
      id="adminorcustomer_organizations_soarrules_serviceaccounts_filter_sensitivity"
      [defaultItem]="{ text: 'All', value: null }"
      textField="text"
      valueField="value"
      [data]="sensitivityFilterOptions"
      [style]="{ width: '200px' }"
      (valueChange)="sensitivityChange($event)"
    ></kendo-dropdownlist>
  </div>
  <button
    id="adminorcustomer_organizations_soarrules_serviceaccounts_addnew"
    type="button"
    class="cyflare-btn-primary align-self-end"
    (click)="openEditor()"
  >
    Add new
  </button>
</div>

@if (datatableUrl(); as url) {
  <app-datatable
    [data-href]="url"
    [columns]="datatableColumns"
    [useOData]="true"
    [initialFilters]="initialFilters"
    (click)="onTableClick($event)"
  ></app-datatable>
}

@if (formGroup(); as form) {
  <kendo-dialog
    [title]="isNew() ? 'Add Service Account' : 'Edit Service Account'"
    [width]="520"
    [minWidth]="340"
    (close)="closeEditor()"
  >
    <form [formGroup]="form">
      <div class="mb-3">
        <label
          class="form-label small text-muted mb-1"
          for="adminorcustomer_organizations_soarrules_serviceaccounts_username"
        >
          Username
        </label>
        <input
          id="adminorcustomer_organizations_soarrules_serviceaccounts_username"
          class="form-control"
          formControlName="username"
        />
      </div>

      <div class="mb-3">
        <label
          class="form-label small text-muted mb-1"
          for="adminorcustomer_organizations_soarrules_serviceaccounts_relatedfunction"
        >
          Related Function
        </label>
        <input
          id="adminorcustomer_organizations_soarrules_serviceaccounts_relatedfunction"
          class="form-control"
          formControlName="related_function"
        />
      </div>

      <div class="mb-2">
        <label class="form-label small text-muted mb-1">Sensitivity/Function</label>
        <kendo-dropdownlist
          id="adminorcustomer_organizations_soarrules_serviceaccounts_sensitivity"
          [data]="sensitivityOptions"
          [valuePrimitive]="true"
          formControlName="sensitivity"
        ></kendo-dropdownlist>
      </div>
    </form>

    <kendo-dialog-actions>
      <button
        id="adminorcustomer_organizations_soarrules_serviceaccounts_cancel"
        type="button"
        class="cyflare-btn-secondary cyflare-btn-sm"
        [disabled]="isSaving()"
        (click)="closeEditor()"
      >
        Cancel
      </button>
      <button
        id="adminorcustomer_organizations_soarrules_serviceaccounts_save"
        type="button"
        class="cyflare-btn-primary cyflare-btn-sm"
        [disabled]="isSaving()"
        (click)="save()"
      >
        @if (isSaving()) {
          <span
            class="spinner-border spinner-border-sm me-1"
            role="status"
          ></span>
          Saving...
        } @else {
          {{ isNew() ? 'Add' : 'Update' }}
        }
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
